<template>
  <div class="common">
    <search-form :formConfig="formConfig" :source="searchData" @search="search" @handleSearch="handleSearch">
      <template slot="btns">
        <a-button type="primary" @click="handleAdd">新增</a-button>
        <a-button type="primary" @click="handleMatch" :disabled="selectedRows.length === 0">匹配框架合同</a-button>
        <a-button type="primary" @click="handleunMatch" :disabled="selectedRows.length === 0">解除框架合同</a-button>
      </template>
    </search-form>
    <div class="table-common">
      <a-table size="middle" :columns="columns" :row-key="record => record.id" :data-source="tableData"
        :pagination="pagination" :loading="loading" bordered :scroll="columns.length>10?{ x: '100%' }:{}"
        :locale="{emptyText: '暂无数据'}" @change="handleTableChange"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }">
        <template slot="contractAmt" slot-scope="text">{{text | splitK}}</template>
        <template slot="signDate" slot-scope="text">{{text | dateFormat('YYYY-mm-dd')}}</template>
        <template slot="createTime" slot-scope="text">{{text | dateFormat('YYYY-mm-dd')}}</template>
        <template slot="operation" slot-scope="text, record">
          <a-button type="link" @click="toPageDetail(record)">查看</a-button>
          <a-button type="link" @click="handleEdit(record)">修改</a-button>
        </template>
      </a-table>
    </div>
    <!-- <transferPdfView ref="transferPdfView"/> -->
    <AddPage ref="AddPage" @success="getTableData"></AddPage>

    <matchPage ref="match" @success="matchSuccess"></matchPage>
  </div>
</template>

<script>
import { invoiceContractList, unMatchMainContract,updateContractFlag } from '@/api/orderContract.js'
import { selectSellerCst } from '@/api/rcvbBuy.js'
import AddPage from './AddPage.vue'
import matchPage from './matchPage.vue'
export default {
  components: {
    AddPage, matchPage
  },
  data() {
    return {
      loading: false,
      searchData: {
        contractNo: undefined,
        sellrOrgCode: undefined,
      },
      formConfig: [
        {
          prop: 'mainContractNo',
          type: 'input',
          label: '框架合同编号',
        },
        {
          prop: 'sellrOrgCode',
          type: 'selectSearch',
          label: '卖方名称',
          option: [],
          searchSource: true,
          headNameFirst: '卖方名称',
          headNameSecond: '社会信用代码',
          valuePorp: 'orgCode',
          labelPorp: 'userName',
          searchHandle: 'handleSearch',
        },
        {
          prop: 'contractNo',
          type: 'input',
          label: '合同编号',
        },
      ],
      columns: [
        {
          title: '框架合同编号',
          dataIndex: 'mainContractNo',
        },
        {
          title: '卖方名称',
          dataIndex: 'sellrName',
          ellipsis: true,
        },
        {
          title: '合同编号',
          dataIndex: 'contractNo',
          scopedSlots: { customRender: 'contractNo' },
        },
        {
          title: '合同金额(元)',
          dataIndex: 'contractAmt',
          scopedSlots: { customRender: 'contractAmt' },
        },
        {
          title: '签署日期',
          dataIndex: 'signDate',
          sorter: true,
          scopedSlots: { customRender: 'signDate' },
        },
        {
          title: '创建日期',
          dataIndex: 'createTime',
          sorter: true,
          scopedSlots: { customRender: 'createTime' },
        },
        {
          title: '合同名称',
          dataIndex: 'contractName',
          scopedSlots: { customRender: 'contractName' },
        },
        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
        },
      ],
      tableData: [],
      selectedRowKeys: [],
      selectedRows: [],
      pagination: {
        pageSize: 10,
        current: 1,
        sortField: 'createTime',
        sortOrder: 'desc',
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ['5', '10', '20', '50', '100'],
        showTotal: (total) => {
          return `共 ${total} 条`
        },
      },
    }
  },
  computed: {
    matchFlag() {
      if (this.selectedRows.length > 0) {
        for (let i = 0; i < this.selectedRows.length; i++) {
          const el = this.selectedRows[i],
            firstEl = this.selectedRows[0]
          if (el.sellrName !== firstEl.sellrName) {
            return true
          }
          if (firstEl.mainContractNo || el.mainContractNo) {
            return true
          }
        }
        return false
      }else{
        return true
      }
    }
  },
  methods: {
    search(data) {
      this.searchData = data || this.searchData
      this.getTableData()
    },
    // 卖方名称选项
    handleSearch(value, data) {
      selectSellerCst({
        pageSize: 10,
        effStCd: 1,
        statusCode: 0,
        state: 2,
        userName: value || '',
        pageNum: 1,
      })
        .then((res) => {
          this.formConfig.forEach((item, index) => {
            if (item.label == '卖方名称') {
              this.formConfig[index].option = res.data.grid.list
              // this.importOption = res.data.grid.list;
            }
          })
        })
        .catch((error) => {
          console.log(error)
        })
    },

    onSelectChange(key, list) {
      this.selectedRowKeys = key;
      this.selectedRows = list
    },

    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.pagination.total = this.pagination.total || 0
      this.pagination.sortField = sorter.field || pagination.sortField;
      this.pagination.sortOrder = sorter.order || pagination.sortOrder;
      this.selectedRowKeys = []
      this.selectedRows = []
      this.getTableData()
    },
    getTableData() {
      this.loading = true
      const params = {
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        useCase: 'receivable',
        mainContractNo: this.searchData.mainContractNo,
        contractNo: this.searchData.contractNo,
        sellrOrgCode: this.searchData.sellrOrgCode && this.searchData.sellrOrgCode.key,
        orderBy: this.pagination.sortField
          ? `${this.pagination.sortField} ${
              this.pagination.sortOrder == "ascend" ? "asc" : "desc"
            }`
          : "",
      }
      invoiceContractList(params)
        .then((res) => {
          this.loading = false
          this.tableData = res.data.grid.list
          this.pagination.total = res.data.grid.total
        })
        .catch((err) => {
          this.loading = false
        })
    },
    handleMatch() {
      if(this.matchFlag){
        this.$message.warning('勾选的卖方名称需一致且未匹配框架合同')
        return false
      }else{
        this.$refs.match.open(this.selectedRows,this.selectedRowKeys)
      }
      
    },
    matchSuccess(){
      this.selectedRowKeys = []
      this.selectedRows = []
      this.getTableData()
    },
    handleunMatch() {
      let self = this
      this.$confirm({
        title: "解除框架合同",
        content: "确认对所勾选的合同进行解除框架合同操作吗？",
        onOk() {
          const params = {
            contractIds: self.selectedRowKeys.join(',')
          };
          unMatchMainContract(params).then(res => {
            self.$message.success("操作成功");
            self.selectedRowKeys = [];
            self.selectedRows = [];
            self.getTableData()
          });
        },
        onCancel() { }
      });
    },
    handleAdd() {
      this.$nextTick(() => {
        this.$refs.AddPage.open()
      })
    },
    handleEdit(row) {
      updateContractFlag(row.id).then(res => {
        this.$refs.AddPage.open(row)
      })
    },
    handleDownload(item) {
      const DOWNLOAD_PREFIX = '/gb-bigtree-file/download/fileDownload/install'
      window.open(
        `${DOWNLOAD_PREFIX}${item.fileRte}/${item.fileNm || item.name}`,
        '_blank'
      )
    },
    toPageDetail(row) {
      this.$nextTick(() => {
        this.$refs.AddPage.open(row, true)
      })
    },
  },
  created() {
    this.getTableData()
  },
  mounted() { },
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/bill-manage/orderContract/list.vue